/* eslint-disable no-unused-vars */
import React, { useState } from 'react';
import { Provider } from 'react-redux';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import './build.css';
import ScrollButton from './components/button/ScrollButton';
import Header from './components/shared/Header';
import Sidebar from './components/shared/Sidebar';
import OrderDetails from './pages/orders/OrderDetailsPage/OrderDetails';
import store from './redux/store';
import pages from './Routes';

function App() {
    const [isSidebarOpen, setIsSidebarOpen] = useState(true);

    return (
        <Router>
            <Provider store={store}>
                <div className="grid grid-cols-12 min-h-screen min-w-full">
                    <Sidebar isOpen={isSidebarOpen} setIsOpen={setIsSidebarOpen} />

                    <div
                        className={` ${
                            isSidebarOpen
                                ? 'col-span-full md:col-start-3 md:col-end-13'
                                : 'col-span-full'
                        }`}
                    >
                        <Header isOpen={isSidebarOpen} setIsOpen={setIsSidebarOpen} />

                        <div>
                            {/* <Switch> */}
                            {pages.map((page) => (
                                <div key={page.id}>
                                    <Route
                                        exact={page.path !== '/settings'}
                                        path={page.path}
                                        key={page.id}
                                        component={page.component}
                                    />
                                </div>
                            ))}
                            {/* </Switch> */}
                        </div>
                        <ScrollButton />
                    </div>
                </div>
            </Provider>
        </Router>
    );
}

export default App;
